import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as C, useState as R, useEffect as V } from "react";
import B from "../Badge/Badge.js";
import I from "../LinkButton/LinkButton.js";
import s from "./Accordion.module.scss.js";
import { clsx as o } from "../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as N } from "../Typography/Typography.js";
import v from "../Icon/Icon.js";
import { Avatar as w } from "../Avatars/Avatar.js";
const L = {
  small: {
    icon: {
      size: "sm",
      className: "pt-075"
    },
    typographyVariant: "interface/medium/s",
    linkSize: "small"
  },
  medium: {
    icon: { size: "md", className: "pt-050" },
    typographyVariant: "interface/medium/sm",
    linkSize: "medium"
  }
}, P = C((p) => {
  const {
    defaultExpanded: x,
    title: y,
    size: z = "medium",
    color: b = "white",
    iconName: u,
    isRounded: S = !0,
    spacing: f = "md",
    description: r,
    disabled: a,
    badgeProps: h,
    linkProps: i,
    className: k,
    avatarProps: n,
    testId: E,
    onChange: m
  } = p, [t, j] = R(!1), l = document.body.getAttribute("dir") === "rtl", c = L[z ?? "medium"], A = () => {
    a || (m == null || m(!t), j((d) => !d));
  };
  return V(() => {
    j(!!x);
  }, [x]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: o(
        s.accordion,
        s[b],
        s[f],
        S && s[`${f}Rounded`],
        a && "opacity-40",
        !t && "!gap-0",
        k
      ),
      children: [
        a && /* @__PURE__ */ e.jsx("div", { className: s.disabled }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: o(s.accordionHeader, {
              "!items-center": !r,
              "!cursor-not-allowed": a
            }),
            role: "button",
            onClick: A,
            "data-testid": E,
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: o(s.firstSection, { "!items-center": !r }), children: [
                n && /* @__PURE__ */ e.jsx(
                  w,
                  {
                    ...n,
                    size: "sm"
                  }
                ),
                u && !n && /* @__PURE__ */ e.jsx("div", { className: c.icon.className, children: /* @__PURE__ */ e.jsx(
                  v,
                  {
                    name: u,
                    size: c.icon.size
                  }
                ) }),
                /* @__PURE__ */ e.jsxs("div", { className: s.titleSection, children: [
                  /* @__PURE__ */ e.jsx("div", { className: "h-[28px]", children: /* @__PURE__ */ e.jsx(
                    N,
                    {
                      text: y,
                      variant: c.typographyVariant
                    }
                  ) }),
                  r && /* @__PURE__ */ e.jsx(
                    N,
                    {
                      text: r,
                      variant: "subtitle-2",
                      textColor: "color/fg/lighter"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: s.secondSection, children: [
                h && /* @__PURE__ */ e.jsx(
                  B,
                  {
                    ...h,
                    size: "small"
                  }
                ),
                i && /* @__PURE__ */ e.jsx(
                  I,
                  {
                    ...i,
                    size: c.linkSize,
                    disabled: a || i.disabled,
                    onClick: (d) => {
                      var g;
                      d.stopPropagation(), (g = i.onClick) == null || g.call(i, d);
                    }
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  v,
                  {
                    name: l ? "chevron-left" : "chevron-right",
                    className: o("text-color-fg-lighter !ease-out !duration-300", {
                      [s.rotate0]: !t,
                      [s.rotate90]: t && !l,
                      [s.rotate_90]: t && l
                    })
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            "data-testid": "accordion-body",
            className: o(s.accordionBody, { [s.expand]: t }),
            children: /* @__PURE__ */ e.jsx("div", { className: s.expandableSection, children: p.children })
          }
        )
      ]
    }
  );
});
P.displayName = "Accordion";
export {
  P as default
};
//# sourceMappingURL=Accordion.js.map
